(function ($, Drupal, window, document) {
  var jQuery = $;
  Drupal.behaviors.win = {
    attach: function (context, settings) {
    }
  };

  jQuery.fn.scroll = function (cb) {
    cb.bind(this);
    var elements = this.get();
    for (var i = 0; i < elements.length; i++) {
      elements[i].addEventListener('scroll', function (e) {
        cb(e);
      }.bind(this), {passive: true});
    }
  };


  function jumpToTop() {
    $('.jump-to-top').on('click', function (e) {
      e.preventDefault();
      document.scrollingElement.scrollTop = 0;
    });

    var to_top_btn = $('.jump-to-top.fixed').get(0);
    var footer_to_top_btn = $('.jump-to-top').first().get(0);
    var lastScrollTop = 0;
    function _check_to_top() {
      var st = $(window).scrollTop();
      var diff = lastScrollTop - st;
      if (st > 300 && (diff > 0 || st > document.scrollingElement.scrollHeight - window.innerHeight * 1.5)) {
        to_top_btn.style.opacity = '1';
        to_top_btn.style.pointerEvents = '';
      } else if (st < 300 || diff <= 0) {
        to_top_btn.style.opacity = '0';
        to_top_btn.style.pointerEvents = 'none';
      }

      lastScrollTop = st;
    }
    function _fix_position() {
      var rect = footer_to_top_btn.getBoundingClientRect();
      to_top_btn.style.left = Math.floor(rect.left)+'px'
      to_top_btn.style.right = 'auto';
      _check_to_top();
    }

    $(window).scroll(function () {
      _check_to_top();
    });
    $(window).resize(_fix_position);

    _fix_position();
    setTimeout( _fix_position, 1500);
  }

  jQuery(document).ready(function () {
    var $ = jQuery;
    video_element();
    carousel();
    searchform();
    contactMap();
    jumpToTop();

    $('.paragraph--event').each(function (i, el) {
      $(el).find('.collapse').first().collapse('show');
    });


    $('.paragraph--story-teaser').each(function (i, el) {
      var jq = $(el).find('.exponat-content-container');
      var head = jq.find('h4').first();
      var rte = jq.find('.rte-default').first();
      var max = jq.parent().height() - head.height() - 120;
      var h = rte.height();
      if (h > max) {
        var f = max / h;
        var len = rte.text().length;
        var text = rte.text().substr(0, len * f).trim() + '...';
        rte.text(text);
        //var html = '<span>' + rte.text().substr(0, len * f).trim() + '</span>'
        //html += '<span title="' + rte.text().substr(len * f).trim() + '">...</span>';
        //rte.html(html);
      }
    });

//Mobile Menu and Mobile search
    $('.menu-toggle-mobile').click(function () {
      $('.menu-toggle-inside').toggleClass('is-opened');
      $('.navbar .navbar-collapse').toggleClass('show');
    });
    $('.search-mobile-toggle').click(function () {
      $(this).toggleClass('search-opened');
      $('.search-container').toggleClass('show')
    });

    $('#user-change-small').click(function () {
      $('html,body').css('font-size', '');
      localStorage.fontSize = 'small';
    });
    $('#user-change-medium').click(function () {
      $('html,body').css('font-size', '22px');
      localStorage.fontSize = 'medium';
    });
    $('#user-change-large').click(function () {
      $('html,body').css('font-size', '24px');
      localStorage.fontSize = 'large';
    });
    setTimeout(function () {
      var size = localStorage.fontSize;
      if (!size) return;
      if (size === 'small') {
        $('html,body').css('font-size', '');
      } else if (size === 'medium') {
        $('html,body').css('font-size', '22px');
      } else if (size === 'large') {
        $('html,body').css('font-size', '24px');
      }
      setTimeout(function () {
        $('html,body').css('transition', 'font-size 200ms ease');
      });
    });
  });

  (function ($) {
    var size = localStorage.fontSize;
    if (!size) return;
    if (size === 'small') {
      $('html,body').css('font-size', '');
    } else if (size === 'medium') {
      $('html,body').css('font-size', '22px');
    } else if (size === 'large') {
      $('html,body').css('font-size', '24px');
    }
  }(jQuery));

//bootstrap carousel
  function carousel() {
    var $ = jQuery;
    var image_carousels = $('.image-carousel, .epoche-carousel');
    var fade_carousels = $('.carousel-fade');

    image_carousels.each(function () {
      var carousel = $(this);
      var active = carousel.children().first();
      var spanIndex = carousel.parent().parent().parent().find('.slider-controlls .image-slider-counter span').first();
      if (!spanIndex.length) spanIndex = carousel.parent().parent().find('.epoche-slider-controlls .slider-counter span').first();
      if (!spanIndex.length) spanIndex = carousel.parent().parent().find('.epoche-slider-controlls .epoche-counter span').first();
      spanIndex.html('1');
      setTimeout(function () {
        active.fadeIn();
      }, 800);
      carousel.carousel({
        interval: 6000,
        pause: false,
        wrap: true
      }).on('slide.bs.carousel slid.bs.carousel', function (ev) {
        if (window.lzi_trigger) window.lzi_trigger();
        var index = $(ev.relatedTarget).index() + 1;
        spanIndex.html('' + index);
      }).carousel('cycle');
    });

    fade_carousels.each(function () {
      var carousel = $(this);
      carousel.carousel({
        interval: 6000,
        pause: false,
        wrap: true
      }).on('slide.bs.carousel slid.bs.carousel', function () {
        if (window.lzi_trigger) window.lzi_trigger();
      }).carousel('cycle');
    });

  }

//serach form
  function searchform() {
    jQuery('.form-type-search input.form-control').on('click', function () {
      jQuery(this).addClass('active-search');
    });

  }

//conatct map
  function contactMap(url, element) {
    if (element) {
      element.onclick = null;
      var container = jQuery(element).parent().parent();
      var iframe = container.parent().find('iframe');
      iframe.attr('src', url);
      iframe.fadeIn(1000);
      jQuery(element).parent().parent().fadeOut(800);
    }
  }

//Youtube video function
  var isYoutubeApiReady = false, isYoutubeApiInitialized = false;
  window.onYouTubePlayerAPIReady = function () {
    isYoutubeApiReady = true;
  };

  function atvPlayVideo(video_id, element, type) {
    element.onclick = null;

    var active_video = null;

    var cr = jQuery(element).parents('.image-carousel');
    if (!cr || !cr.length) cr = null;
    if (cr) {
      cr.on('slide.bs.carousel slid.bs.carousel', function (ev) {
        if (active_video) {
          active_video.pauseVideo();
          cr.carousel('cycle');
          active_video = null;
        }

      });
    }
    if (!isYoutubeApiInitialized) {
      isYoutubeApiInitialized = true;
      var tag = document.createElement('script');
      tag.src = "https://www.youtube.com/player_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function _play() {
      if (cr) cr.carousel("pause");
      if (isYoutubeApiReady) {
        var image = element.parentNode.children[1];
        var container = element.parentNode.children[0];
        var player = new YT.Player(container, {
          // width: width,
          // height: height,
          playerVars: {
            'autoplay': 0,
            'rel': 0,
            'controls': 1
          },
          videoId: video_id,
          events: {
            'onReady': function () {
              player.playVideo();
              active_video = player;
              // stop & hide animation
              setTimeout(function () {
                jQuery(image).fadeOut();
                jQuery(element).fadeOut();
                jQuery(element.parentNode).find('.video-footer').hide();
                jQuery(element.parentNode.parentNode).find('.ds-footer').hide();
              }, 150);
            }
          }
        });
      } else {
        setTimeout(_play, 100);
      }
    }

    _play();
  }

  window.atvPlayVideo = atvPlayVideo;

//responsive video function
  function video_element() {
    var mob_video = document.getElementsByClassName("mobile-video");
    var desk_video = document.getElementsByClassName("desktop-video");
    for (var i = 0; i < mob_video.length; i++) {
      if (window.innerWidth <= 767) {
        mob_video[i].autoplay = true;
        mob_video[i].load();
      }
    }
    for (i = 0; i < desk_video.length; i++) {
      if (window.innerWidth <= 767) {
        desk_video[i].autoplay = false;
        desk_video[i].pause();

      }
    }
  }


})(jQuery, Drupal, window, document);
